<template>
  <div class="common-header-container">
    <div class="common-header-content">
      <div class="logo-container">
        <img :src="SopremaLogo" />
      </div>
      <p class="title">Le Grand Charles</p>
    </div>
  </div>
</template>

<script lang="ts" setup>
import SopremaLogo from '../../assets/logo.png'
</script>

<style lang="scss" scoped>
.common-header {
  &-container {
    padding: var(--spacer) 0;
    height: 100%;
    display: flex;
  }

  &-content {
    display: flex;
    align-items: flex-end;
    gap: var(--spacer);

    .logo-container {
      display: flex;
      height: 100%;

      img {
        height: 100%;
      }
    }

    .title {
      font-size: 34px;
      line-height: 0.8;
      margin-bottom: 0;
      font-weight: 300;
      color: var(--vc-primary);
    }
  }
}
</style>
